export enum MonitoringPlanType {
  NA = 0,
  Backup = 1,
  Restore = 2,
  BackupFiles = 3,
  RestoreFiles = 4,
  VMBackup = 5,
  VMRestore = 6,
  SQLBackup = 7,
  SQLResore = 8,
  ExchangeBackup = 9,
  ExchangeRestore = 10,
  BMSSBackup = 11,
  BMSSRestore = 12,
  ConsistencyCheck = 13,
  EC2Backup = 14,
  EC2Restore = 15,
  HyperVBackup = 16,
  HyperVRestore = 17,
  ProxmoxBackup = 18,
  ProxmoxRestore = 19
}

export const MonitoringRestorePlanType = new Set([
  MonitoringPlanType.Restore,
  MonitoringPlanType.RestoreFiles,
  MonitoringPlanType.VMRestore,
  MonitoringPlanType.SQLResore,
  MonitoringPlanType.ExchangeRestore,
  MonitoringPlanType.BMSSRestore,
  MonitoringPlanType.EC2Restore,
  MonitoringPlanType.HyperVRestore,
  MonitoringPlanType.ProxmoxRestore
]);
